<template>
  <div class="switch_body">
    <div class="switch_label" :style="labelStyle">
      <span>{{ value.itemName }}</span>
      <el-input
        v-number:integer
        v-show="value.hasItemThreshold"
        style="width: 60px"
        v-model="value.itemThreshold"
        v-integer-or-two-decimal="value.limit"
        />
        <!-- v-interage="true" -->
      <span v-show="value.hasItemThreshold">{{ value.itemThresholdUnit }}</span>
    </div>
    &nbsp;
    <span :class="{color_active: closeState}">关闭</span>
    <el-switch
      v-model="value.state"
      @change="handleChange"
      :active-value="activeValue"
      :inactive-value="inactiveValue"
      :disabled="value.hasOwnProperty('mutable') ? !value.mutable : true"
    >
  </el-switch>
  <span :class="{color_active: openState}">开启</span>
  <span v-show="value.hasOwnProperty('describe')" class="switch_describe">{{ value.describe }}</span>
  </div>
</template>
<script>
export default {
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    labelWidth: {
      type: [Number, String],
      default: 200,
    },
    activeValue: {
      type: [Boolean, String, Number],
      default: true,
    },
    inactiveValue: {
      type: [Boolean, String, Number],
      default: false,
    },
  },
  data() {
    return {
    }
  },
  computed: {
    labelStyle() {
      const ret = {}
      if (this.labelWidth > 0) {
        ret.width = `${this.labelWidth}px`
      } else {
        ret.width = '200px'
      }
      return ret
    },
    closeState() {
      return this.value.state === this.inactiveValue
    },
    openState() {
      return this.value.state === this.activeValue
    },
  },
  methods: {
    handleChange() {
      // this.$emit('input', val)
    },
  },
}
</script>
<style lang="scss" scoped>
.switch_body {
  display: inline-block;
  margin-bottom: 18px;
  margin-right: 20px;
}
.switch_label{
  display: inline-block;
  font-weight: 450;
  text-align: right;
}
.switch_describe {
  margin-left: 20px;
  font-size: 14px;
  color: #666;
}
.color_active{
  color: #276BEC;
}
</style>>
